import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';

export default () => (
  <InformationalModule
    // configs
    sectionId='long-term-care-planning-intro'
    moduleName='intro-module'
    moduleVariation='A'
    disableBottomPadding
    // content
    headingText={<>What is long&#45;term care, and will I <WidowBlock>need it&#63;</WidowBlock></>}
    introContent={(
      <>
        <Typography
          align='left'
          nextElement='button'>
          Many people think they won&#39;t need long&#45;term care; however, research suggests they&#39;ll need it at some point in their life.<sup>1</sup> And age isn&#39;t the only reason. A chronic illness or debilitating injury that keeps you from living on your own or properly caring for yourself can happen no matter how old you are. Many people also think that the costs of long&#45;term care will be completely covered by health insurance or Medicare&#8212;but they&#39;re typically not. That&#39;s why it&#39;s important to have a plan in place. Our advisors will help you figure out the best option for you and your loved ones.
        </Typography>
        <Link
          id='long-term-care-planning-intro-cta-fafa'
          variant='buttonLinkPrimary'
          linkUrl='/find-a-financial-advisor/'
          ariaLabel='Get started with a financial advisor'>
          Get started
        </Link>
      </>
    )}
  />
);
